import { render } from "./HomeWhyExive.vue?vue&type=template&id=61d2c5ef&scoped=true&ts=true"
import script from "./HomeWhyExive.vue?vue&type=script&lang=ts"
export * from "./HomeWhyExive.vue?vue&type=script&lang=ts"

import "./HomeWhyExive.vue?vue&type=style&index=0&id=61d2c5ef&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d2c5ef"]])

export default __exports__